module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("网站banner设置")])])], 1), _vm._v(" "), _c('el-form', {
    ref: "bannerForm",
    attrs: {
      "model": _vm.bannerForm,
      "rules": _vm.bannerFormFules
    }
  }, [(_vm.bannerForm.value) ? _c('el-form-item', {
    attrs: {
      "label": "标题：",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描述",
      "label-width": "150px",
      "prop": "description"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.bannerForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "remark", $$v)
      },
      expression: "bannerForm.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "类型选择",
      "label-width": "150px",
      "prop": "shop"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "商品"
    },
    on: {
      "change": _vm.productChoose
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.bannerForm.value && _vm.type === 'video') ? _c('el-form-item', {
    attrs: {
      "label": "视频链接",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.videoUrl),
      callback: function($$v) {
        _vm.videoUrl = $$v
      },
      expression: "videoUrl"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bannerForm.value && _vm.type === 'video') ? _c('el-form-item', {
    attrs: {
      "label": "视频封面",
      "label-width": "150px"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "https://upload.qiniup.com/",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "on-error": _vm.handleError,
      "before-upload": _vm.beforeAvatarUpload,
      "data": _vm.uptoken
    }
  }, [(_vm.imgUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imgUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'pic') ? _c('el-form-item', {
    attrs: {
      "label": "封面图：",
      "label-width": "150px"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": "https://upload.qiniup.com/",
      "file-list": _vm.fileListDetail,
      "on-error": _vm.handleError,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.handleDetailRemove,
      "on-success": _vm.handleDetailSuccess,
      "before-upload": _vm.beforeDetailUpload,
      "data": _vm.uptoken
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c942d69e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/other/Banner.vue
// module id = 753
// module chunks = 1